import Head from 'next/head'
import IndexContent from '../components/IndexContent'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import HeroSearch from '../components/HeroSearch'
import OnlineTutoringHero from '../components/OnlineTutoringHero'

export default function OnlineTutoring() {
  return (
    <>
      <Head>
        <title>Professional Online Tutoring | Learn the Easy Way with Tutorspot</title>
      </Head>

      <OnlineTutoringHero />

      <div className="mb-5">
        <IndexContent />
      </div>

      <div className="bg-white">
        <Container>
          <Row>
            <Col xs={12} md={10} className="offset-md-1 pt-4 mb-5">
              <div className="text-center">
                <h3>Get Started with Online Tutoring Today</h3>
              </div>
              <HeroSearch />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
